import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useLocation, useNavigate } from "react-router-dom";
import "./HelpEdit.css";
import { patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import moment from "moment";

export const HelpEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode, page } = location.state || {};
  const isViewMode = mode === "view";

  const [formData, setFormData] = useState({
    username: "",
    datetime: "",
    status: "",
    description: "",
    reply_message: "",
  });
  const isEditMode = formData.status !== "Viewed";

  useEffect(() => {
    if (data) {
      setFormData({
        username: data?.delivery_partner_name || "",
        datetime:
          moment(data?.created_at).format("DD-MM-YYYY hh:mm:ss A") || "",
        status: data?.status_display || "",
        description:
          data?.query ||
          "Order cancelled because the home chef ran out of extra servings.",
        reply_message: data?.reply || "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));
  };

  const handleViewed = async () => {
    try {
      if (!data?.id) return;

      let res = await patch(URLS.DELIVERYHELP, {
        ticket_id: data.id,
        status: 1,
      });
      if (res?.status === "success") {
        toast.success(res?.message || "Marked as viewed successfully");
        navigate("/delivery-help", { state: { page: page || 1 } });
      } else {
        toast.error(res?.message || "Failed to mark as viewed");
      }
    } catch (error) {
      console.error("Error marking as viewed:", error);
      toast.error(error?.message || "An error occurred");
    }
  };

  const getStatusColor = () => {
    const statusValue = formData.status || "";
    if (statusValue === "Viewed") return "green";
    if (statusValue === "Created") return "#FF8F00";
    return "red";
  };

  const handleReplyChange = async () => {
    if (!formData.reply_message) {
      toast.info("Reply message is required");
      return;
    }
    if (!data?.id) return;
    const res = await post(`${URLS.DELIVERYHELP}`, {
      reply: formData.reply_message,
      ticket_id: data.id,
    });
    console.log("res reply", res);
    if (res?.status === "success") {
      toast.success(res?.message || "Reply sent successfully");
      navigate("/delivery-help", { state: { page: page || 1 } });
    } else {
      toast.error(res?.message || "Failed to mark as viewed");
    }
  };

  return (
    <>
      <PageHeader
        title="Delivery Partner Support"
        showBackButton={true}
        onBackClick={() =>
          navigate("/delivery-help", { state: { page: page || 1 } })
        }
      />
      <div className="help-edit-container">
        <div className="help-edit-form">
          <div className="form-row">
            <div className="form-group">
              <label>User Name</label>
              <input
                type="text"
                name="username"
                value={formData.username || ""}
                onChange={handleChange}
                // disabled={!isEditMode}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Date & Time</label>
              <input
                type="text"
                name="datetime"
                value={formData.datetime || ""}
                onChange={handleChange}
                // disabled={!isEditMode}
                readOnly
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Status</label>
              <input
                type="text"
                name="status"
                value={formData.status || ""}
                onChange={handleChange}
                // disabled={!isEditMode}
                readOnly
                style={{ color: getStatusColor(), fontWeight: 500 }}
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                name="description"
                value={formData.description || ""}
                onChange={handleChange}
                // disabled={!isEditMode}
                readOnly
                rows={4}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Reply Message</label>
              <textarea
                type="text"
                name="reply_message"
                value={formData.reply_message || ""}
                onChange={handleChange}
                // disabled={!isEditMode2}
                // readOnly={!isEditMode2}
                rows={4}
              />
            </div>
          </div>

          <button
            type="button"
            className="btn-viewed"
            onClick={handleReplyChange}
          >
            Reply
          </button>
          {formData.status === "Pending" && (
            <div className="form-actions">
              <button
                type="button"
                className="btn-viewed"
                onClick={handleViewed}
              >
                Viewed
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
